export default __webpack_public_path__ + "static/media/tvshow1.4b3d699b.jpeg";